export default { sha: 'c87a8a598b4b927954275893666f0c4cae68dabf', buildNumber: 'undefined' }
